export default __webpack_public_path__ + "static/media/paused-icon.857fb8f2.svg";